module.exports = __webpack_public_path__ + "assets/nexia_logo-44729d32-pivot.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styl/images/nexia_logo.svg
// module id = 320
// module chunks = 47